"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInlineSelectCellFactory = void 0;
const react_1 = __importStar(require("react"));
const form_select_1 = require("../../../composite/form/fields/form-select");
const inline_table_context_1 = require("../inline-table-context");
function useInlineSelectCellFactory(props) {
    return (0, react_1.useMemo)(() => function InlineCell(tableFieldProps) {
        return (react_1.default.createElement(InlineSelectCell, { inlineProps: props, tableFieldProps: tableFieldProps }));
    }, [props]);
}
exports.useInlineSelectCellFactory = useInlineSelectCellFactory;
function InlineSelectCell({ inlineProps, tableFieldProps, }) {
    const { disabled: tableDisabled } = (0, react_1.useContext)(inline_table_context_1.InlineTableFieldContext);
    const { isSubkey = true, collectionDatakey, disabled, multiple, valueIsId, notifyChange, dataHook, labelMapper, } = inlineProps;
    const { index, column } = tableFieldProps;
    const source = dataHook();
    return (react_1.default.createElement(form_select_1.FormSelect, { name: isSubkey
            ? `${collectionDatakey}[${index}].${column.datakey}`
            : `${collectionDatakey}[${index}]`, source: source, multiple: multiple, labelOptions: { hide: true }, layoutOptions: { noUnderline: true }, valueIsId: valueIsId, disabled: tableDisabled ||
            (typeof disabled === 'function' ? disabled(index) : disabled), notifyChange: () => notifyChange === null || notifyChange === void 0 ? void 0 : notifyChange(index), labelMapper: labelMapper }));
}
//# sourceMappingURL=inline-select-cell.js.map